import { render, staticRenderFns } from "./PrepareForVerificationSvg.vue?vue&type=template&id=1b40f20d&"
import script from "./PrepareForVerificationSvg.vue?vue&type=script&lang=ts&"
export * from "./PrepareForVerificationSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports